import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import Login from "../features/pages/Login/Login";
import MainLayout from "../features/layout/MainLayout";
import Dashboard from "../features/pages/Dashboard/Dashboard";
import LicenseUpload from "src/features/pages/admin/LicenseUpload";
import { ToastContainer, Slide } from "react-toastify";
import VersionWatcher from "src/features/deploy/VersionWatcher";
import Designer from "src/features/pages/Designer/Designer";
import Designer2 from "src/features/pages/Designer2/Designer";
import RequireAdmin from "src/features/pages/admin/RequireAdmin";
import { LicenseManager } from "ag-grid-enterprise";
import ShareLanding from "src/features/pages/Share/ShareLanding";
import QuerySwitch from "src/features/pages/Config/QuerySwitch";
import ClearQueryLog from "src/features/pages/Config/ClearQueryLog";
import GetQueryLogs from "src/features/pages/Config/GetQueryLogs";
import GetIpQueryLogs from "src/features/pages/Config/GetIpQueryLogs";
import ProfilerBridge from "src/features/pages/Config/ProfilerBridge";

import {
  ModuleRegistry,
  ClientSideRowModelModule,
  TextEditorModule,
  NumberEditorModule,
  CheckboxEditorModule,
  RichSelectModule,
  AllEnterpriseModule,
  CustomEditorModule,
} from "ag-grid-enterprise";

ModuleRegistry.registerModules([
  AllEnterpriseModule,
  TextEditorModule,
  ClientSideRowModelModule,
  NumberEditorModule,
  CheckboxEditorModule,
  RichSelectModule,
  CustomEditorModule,
]);

LicenseManager.setLicenseKey(
  "[TRIAL]_this_{AG_Charts_and_AG_Grid}_Enterprise_key_{AG-076336}_is_granted_for_evaluation_only___Use_in_production_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_purchasing_a_production_key_please_contact_info@ag-grid.com___You_are_granted_a_{Single_Application}_Developer_License_for_one_application_only___All_Front-End_JavaScript_developers_working_on_the_application_would_need_to_be_licensed___This_key_will_deactivate_on_{31 March 2025}____[v3]_[0102]_MTc0MzM3NTYwMDAwMA==c6567fdb808acaba121aed5798506e61"
);

const App: React.FC = () => {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/Designer" element={<Designer />} />
        <Route path="/Designer2" element={<Designer2 />} />
        {/* <Route path="/Designer/menu-create" element={<MenuCreatePage />} /> */}
        <Route path="/share/:token" element={<ShareLanding />} />

        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="/*" element={<MainLayout />}>
          <Route path="dashboard" element={<Dashboard />} />
        </Route>
        <Route
          path="/admin/LicenseUpload"
          element={
            <RequireAdmin>
              <LicenseUpload />
            </RequireAdmin>
          }
        />
        <Route path="/querySwitch" element={<QuerySwitch />} />
        <Route path="/clearQueryLog" element={<ClearQueryLog />} />
        <Route path="/getQueryLogs" element={<GetQueryLogs />} />
        <Route path="/GetIpQueryLogs" element={<GetIpQueryLogs />} />
        <Route path="/profilerBridge" element={<ProfilerBridge />} />
      </Routes>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        transition={Slide}
        toastClassName={() =>
          "bg-white text-gray-900 text-sm pl-5 pr-8 py-3 rounded-xl shadow-lg whitespace-pre-wrap inline-flex items-start gap-2 max-w-[80vw] mb-4"
        }
      />
      <VersionWatcher />
    </Router>
  );
};

export default App;
